import { useEffect } from "react";
import { useMctFlags } from "./flag-hooks/useMctFlags";

export const useDesignSystemOverrides = () => {
  const { tmpFeEnableMgovReskin } = useMctFlags();

  useEffect(() => {
    const root = document.documentElement;

    if (tmpFeEnableMgovReskin) {
      root.classList.add("mgov-redesign-enabled");
    } else {
      root.classList.remove("mgov-redesign-enabled");
    }

    return () => {
      root.classList.remove("mgov-redesign-enabled");
    };
  }, [tmpFeEnableMgovReskin]);
};
